import styled from 'styled-components';
import { Button, Layout, Table, Typography } from 'antd';

import colors from '../../styles/colors';

const { Content } = Layout;

export const Wrapper = styled(Content)`
  display: flex;
  flex-direction: column;
  padding: 14px 15px 0 13px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0px;
`;

export const ContainerFilter = styled.div`
  width: 100%;
  margin: 0px 0;
  .ant-input-affix-wrapper,
  .ant-input-affix-wrapper-lg {
    background-color: ${colors.gbGrey};
    padding: 12px 9px;
    border: none;
    .ant-input-prefix {
      color: ${colors.verde};
      margin-left: 8px;
    }
    input {
      background-color: ${colors.gbGrey};
      font-size: 14px;
      font-weight: 20px;
      color: ${colors.greyText};
      margin-left: 8px;
    }
  }
`;

export const ButtonGrid = styled(Button)`
  background-color: ${colors.verde} !important;
  color: ${colors.branco} !important;
  border-radius: 2px !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  border: none;
  height: auto;
  padding: 0.5px 6px;
  &:hover {
    transform: scale(1.2);
  }
`;

export const ContainerTable = styled.div`
  width: 100%;
`;

export const TableCustom = styled(Table)`
  .ant-table-thead ::before {
    display: none;
  }
  .ant-table-thead > tr > th {
    border-bottom: 2px solid #cacaca;
    background-color: ${colors.branco};
    color: ${colors.greyText};
  }
  .ant-table table {
    padding-right: 6px;
  }
  .ant-table-tbody > tr > td {
    border-bottom: none;
    font-size: 14px;
    color: #828282;
    padding: 6px;
  }
  .ant-table-cell-scrollbar {
    display: none;
  }
`;

export const LabelStatus = styled(Typography.Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: ${props => props.cor || '#707070'};
`;

export const TextCustom = styled(Typography.Text)`
  .ant-typography {
    width: 100%;
    white-space: normal !important;
    text-align: center;
  };
`;
